export default __webpack_public_path__ + "static/media/bird.36980717.png";